import { COLOR_FORMAT_HEX, COLOR_FORMAT_RGB } from './ColorPicker.constants'

export function isColorFormatRgb(format) {
  return format === COLOR_FORMAT_RGB
}

export function isColorFormatHex(format) {
  return format === COLOR_FORMAT_HEX
}
